import React, { useState, useEffect } from 'react';
import { Card, Button, Badge, PageHeader } from '../../components/ui';
import api from '../../services/api';

export default function Scheduling() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchScheduled(); }, []);

  const fetchScheduled = async () => {
    try { const r = await api.get('/campaigns'); setCampaigns((r.data.data || []).filter(c => c.status === 'scheduled' || c.scheduledAt)); }
    catch {} finally { setLoading(false); }
  };

  return (
    <div>
      <PageHeader title="Scheduling" subtitle="View and manage scheduled campaigns" />
      {loading ? <div style={{ color:'#555', textAlign:'center', padding:40 }}>Loading...</div> : (
        campaigns.length === 0 ? (
          <Card style={{ textAlign: 'center', padding: 60 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📅</div>
            <h3 style={{ color: '#ccc', marginBottom: 8 }}>No scheduled campaigns</h3>
            <p style={{ color: '#555', fontSize: 14 }}>Schedule a campaign from the Campaigns page to see it here.</p>
          </Card>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {campaigns.map(c => (
              <Card key={c.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 4 }}>{c.name}</div>
                  <div style={{ fontSize: 12, color: '#555' }}>📅 {c.scheduledAt ? new Date(c.scheduledAt).toLocaleString() : 'Not scheduled'}</div>
                  <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>⏰ Asia/Kolkata</div>
                </div>
                <Badge color="info">Scheduled</Badge>
              </Card>
            ))}
          </div>
        )
      )}
    </div>
  );
}
